import { render, staticRenderFns } from "./UploadQueue.vue?vue&type=template&id=3b96d3b0&scoped=true&"
import script from "./UploadQueue.vue?vue&type=script&lang=js&"
export * from "./UploadQueue.vue?vue&type=script&lang=js&"
import style0 from "./UploadQueue.vue?vue&type=style&index=0&id=3b96d3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96d3b0",
  null
  
)

export default component.exports